// src/pages/Grades.js
import React from 'react';
import { Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const Grades = () => {
  // Sample data; replace with real data
  const grades = [
    { course: 'Mathematics 101', grade: 'A' },
    { course: 'Physics 201', grade: 'B+' },
    { course: 'Chemistry 301', grade: 'A-' },
  ];

  return (
    <TableContainer component={Paper}>
      <Typography variant="h5" gutterBottom sx={{ padding: 2 }}>
        Your Grades
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Course</TableCell>
            <TableCell>Grade</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {grades.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{row.course}</TableCell>
              <TableCell>{row.grade}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Grades;
